import React from 'react';
import { Helmet } from 'react-helmet-async';
import Footer from '../components/Footer';
import '../styles/privacy-policy.scss';

const PrivacyPolicy = () => {
  return (
    <main className="privacy_policy_wrapper">
      <Helmet>
        <html lang="uk" />
        <title>Політика конфіденційності | Lima Hookah</title>
        <meta
          name="description"
          content="Політика конфіденційності сайту Lima Hookah"
        />
        <link rel="canonical" href="/privacy-policy" />
      </Helmet>

      <article className="privacy_policy_content">
        <header className="privacy_policy_heading">
          <h1>Політика конфіденційності</h1>
          <p className="privacy_policy_updated">
            Lima Hookah · Останнє оновлення: 18 серпня 2026 року
          </p>
        </header>

        <p>
          Ця Політика конфіденційності описує, як Lima Hookah (далі — «ми»,
          «нас», «наш») збирає, використовує та захищає інформацію відвідувачів
          сайту limahookah.com (далі — «Сайт»).
        </p>

        <section>
          <h2>1. Яку інформацію ми збираємо</h2>
          <p>
            Залежно від того, як ви взаємодієте із Сайтом, ми можемо збирати:
          </p>
          <ul>
            <li>
              <strong>Контактні дані</strong>, які ви добровільно надаєте через
              форми зворотного зв’язку, бронювання столика чи заявки (ім’я,
              номер телефону, e-mail).
            </li>
            <li>
              <strong>Технічні дані</strong>, що збираються автоматично: тип
              пристрою, браузер, IP-адреса, переглянуті сторінки та час візиту —
              за допомогою cookie-файлів і подібних технологій.
            </li>
            <li>
              <strong>Дані аналітики</strong>, якщо на Сайті використовуються
              сервіси на кшталт Google Analytics, — для розуміння того, як
              відвідувачі користуються Сайтом.
            </li>
          </ul>
        </section>

        <section>
          <h2>2. Для чого ми використовуємо цю інформацію</h2>
          <ul>
            <li>Для обробки бронювань та зворотного зв’язку.</li>
            <li>Для покращення роботи Сайту та якості сервісу.</li>
            <li>Для аналітики відвідуваності та вдосконалення контенту.</li>
            <li>Для комунікації з вами щодо ваших запитів.</li>
          </ul>
          <p>
            Ми не продаємо і не передаємо ваші персональні дані третім особам
            для маркетингових цілей без вашої згоди.
          </p>
        </section>

        <section>
          <h2>3. Файли cookie</h2>
          <p>
            Сайт може використовувати cookie-файли для коректної роботи та
            аналітики. Ви можете вимкнути cookie в налаштуваннях свого браузера
            — це може вплинути на деякі функції Сайту.
          </p>
        </section>

        <section>
          <h2>4. Захист даних</h2>
          <p>
            Ми вживаємо розумних технічних та організаційних заходів для
            захисту наданої вами інформації від несанкціонованого доступу,
            зміни чи втрати.
          </p>
        </section>

        <section>
          <h2>5. Сторонні сервіси</h2>
          <p>
            Сайт може містити посилання на сторонні ресурси (соціальні мережі,
            сервіси бронювання тощо). Ми не несемо відповідальності за політику
            конфіденційності цих сторонніх сайтів.
          </p>
        </section>

        <section>
          <h2>6. Ваші права</h2>
          <p>Ви маєте право:</p>
          <ul>
            <li>дізнатися, які дані про вас зберігаються;</li>
            <li>
              вимагати виправлення або видалення своїх персональних даних;
            </li>
            <li>відкликати згоду на обробку даних у будь-який момент.</li>
          </ul>
          <p>Для реалізації цих прав звертайтеся за контактами нижче.</p>
        </section>

        <section>
          <h2>7. Зміни до цієї Політики</h2>
          <p>
            Ми можемо періодично оновлювати цю Політику конфіденційності.
            Актуальна версія завжди доступна на цій сторінці.
          </p>
        </section>

        <section>
          <h2>8. Контакти</h2>
          <p>З питань щодо цієї Політики конфіденційності звертайтеся:</p>
          <ul className="privacy_policy_contacts">
            <li>
              Instagram:{' '}
              <a
                href="https://instagram.com/lima_teremki"
                target="_blank"
                rel="noreferrer"
              >
                @lima_teremki
              </a>{' '}
              /{' '}
              <a
                href="https://instagram.com/lima_hookah_makeevskaya"
                target="_blank"
                rel="noreferrer"
              >
                @lima_hookah_makeevskaya
              </a>
            </li>
            <li>
              Сайт: <a href="https://limahookah.com">limahookah.com</a>
            </li>
          </ul>
        </section>
      </article>

      <Footer />
    </main>
  );
};

export default PrivacyPolicy;
